import React from "react";
import { Form, Formik } from "formik";
import { mergeStyles } from "office-ui-fabric-react";
import { useTranslation } from "react-i18next";

import NewFormBtns from "../../../common/layout/form/NewFormBtns";
import NewFormField from "../../../common/layout/form/NewFormField";
import { resetPassSchema } from "../../actions/resetPassSchema";

const wrapper = mergeStyles({
  marginTop: 20,
});

export interface ResetPassFormProps {
  handleReset: any;
  loading: boolean;
  cancelForm: () => void
}

const ResetPassForm: React.FC<ResetPassFormProps> = ({
  handleReset,
  loading,
  cancelForm
}) => {
  const { t } = useTranslation("admin");
  return (
    <div className={wrapper}>
      <Formik
        initialValues={{}}
        validationSchema={resetPassSchema}
        onSubmit={handleReset}
      >
        {({ handleSubmit }) => (
          <Form translate="yes" onSubmit={handleSubmit}>
            <NewFormField name="password" label={t("auth.formLabels.password") as string} type="password" />
            <NewFormField
              name="passwordConfirm"
              label={t("nav.confirmPassword") as string}
              type="password"
            />
            <NewFormBtns
              submitBtnText={t("nav.resetPass") as string}
              cancelBtnText={t("nav.goBack") as string}
              disabled={loading}
              cancelForm={cancelForm}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ResetPassForm;
